"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDirectionFromReservationStatus = void 0;
function getDirectionFromReservationStatus(status) {
    switch (status) {
        case "booked":
        case "started":
        case "in-activity":
            return "departure";
        case "done":
        case "finalize":
            return "return";
        default:
            return undefined;
    }
}
exports.getDirectionFromReservationStatus = getDirectionFromReservationStatus;
//# sourceMappingURL=direction.js.map